var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getType(),{tag:"component",attrs:{"notification":_vm.notification,"notification-service":_vm.notificationService},on:{"delete-notification":_vm.deleteNotification}})}
var staticRenderFns = []

export { render, staticRenderFns }